document.addEventListener('DOMContentLoaded', () => {

  /*
  -----------------------------------
  CART DRAWER REFRESH
  -----------------------------------
  */

const refreshCartDrawer = async (variantId) => {

  try {

    const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    const sections = await sectionsRes.json();

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {

      // Remove is-empty class before rendering
      cartDrawer.classList.remove('is-empty');

      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) {
        drawerInner.classList.remove('is-empty');
      }

      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({
          id: variantId,
          sections: sections
        });
      }

    }

  } catch (err) {
    console.error('Cart drawer refresh error:', err);
  }

};

  /*
  -----------------------------------
  ADDON — ADD TO CART BUTTONS
  -----------------------------------
  */

  document.querySelectorAll('.addon-atc-btn').forEach((btn) => {

    btn.addEventListener('click', async () => {

      if (btn.classList.contains('is-loading')) return;

      const variantId = btn.dataset.variantId;
      const originalText = btn.textContent;

      if (!variantId) {
        console.error('No variant ID found on button');
        return;
      }

      btn.classList.add('is-loading');
      btn.textContent = '...';

      try {

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1 }]
          })
        });

        if (!response.ok) {
          const err = await response.json();
          console.error('Cart API error:', err);
          throw new Error(err.description || 'Add to cart failed');
        }

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓ Hinzugefügt';

        // Pass variantId so renderContents knows which item was added
        await refreshCartDrawer(parseInt(variantId));

        setTimeout(() => {
          btn.classList.remove('is-added');
          btn.textContent = originalText;
        }, 2500);

      } catch (error) {
        console.error('Addon ATC error:', error);
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
      }

    });

  });

  /*
  -----------------------------------
  ADDONS SLIDER
  -----------------------------------
  */

  const sliderContainer = document.querySelector('.addons-slider-container');
  const nextBtn = document.querySelector('.addons-next');
  const prevBtn = document.querySelector('.addons-prev');

  if (sliderContainer && nextBtn && prevBtn) {

    const getScrollAmount = () => {
      const card = sliderContainer.querySelector('.addon-card');
      if (!card) return 700;
      return card.offsetWidth + 16;
    };

    nextBtn.addEventListener('click', () => {
      sliderContainer.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    prevBtn.addEventListener('click', () => {
      sliderContainer.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

  }

}); // DOMContentLoaded